import { SiafLiteApiRepository } from "../../external";

class NfseService {
  constructor() {
    this.urlBase = "faturamento/nfse";
    this.urlBaseEvent = `/event/${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  cadastrarServico(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/servicos`,
    ).post(body);
  }

  deletarServico(id, idServico) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/servicos`,
    ).delete(idServico);
  }

  atualizarServico(id, idServico, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/${id}/servicos`).put(
      idServico,
      body,
    );
  }

  emitirNotaFiscal(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/emitir`,
    ).getById("");
  }

  getDanfe(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/danfe`,
    ).getById("");
  }

  cancelar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(
      id,
      body,
      "nota-fiscal/cancelamento",
    );
  }

  getArquivoXml(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/nota-fiscal/xml/arquivo`,
    ).get();
  }
}

export default NfseService;
